import {DTVersion} from 'common/src/modules/decisionTree/decisionTree.types';
import {AICampaignVersionStatus} from 'common/src/modules/campaigns/copilot/copilotCampaigns.enums';

export default function getAICampaignVersionStatus(version: DTVersion): AICampaignVersionStatus {
  if (version.isDraft) {
    return AICampaignVersionStatus.Draft;
  }

  if (version.isActivated) {
    return AICampaignVersionStatus.Active;
  }

  if (version.isPendingActivation) {
    return AICampaignVersionStatus.PendingActivation;
  }

  return AICampaignVersionStatus.Saved;
}
